<script setup>
import { HomeIcon } from '@heroicons/vue/24/outline';
import { ChevronRightIcon } from '@heroicons/vue/20/solid';
import { Link, usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

const page = usePage();
const items = computed(() => page.props.navigations.breadcrumb);
const homeUrl = computed(() => page.props.homeUrl);
</script>

<template>
    <nav
        class="hidden lg:block"
        role="navigation"
    >
        <div
            v-if="items && items.length > 0"
            class="text-deep-teal-700 purple-theme:text-purple-700 overflow-x-auto pb-4"
        >
            <ol class="flex items-center space-x-1">
                <li class="inline-flex items-center space-x-1">
                    <Link
                        :href="homeUrl"
                        class="hover:text-sunset-orange-500 hover:purple-theme:text-purple-500 focus:text-sunset-orange-500 focus:purple-theme:text-purple-500 focus:outline-none"
                    >
                        <span class="sr-only">Home</span>
                        <HomeIcon
                            class="size-6"
                            aria-hidden="true"
                        />
                    </Link>
                </li>

                <li
                    v-for="(item, index) in items"
                    :key="index"
                    class="inline-flex items-center space-x-1"
                >
                    <ChevronRightIcon
                        class="size-5 shrink-0"
                        aria-hidden="true"
                    />

                    <Component
                        :is="!item.is_current ? Link : 'span'"
                        :href="!item.is_current ? item.permalink : null"
                        :title="item?.originalTitle ?? null"
                        class="font-semibold text-base/snug line-clamp-1 hover:text-sunset-orange-500 hover:purple-theme:text-purple-500 focus:purple-theme:text-purple-500 focus:text-sunset-orange-500 focus:outline-none"
                        :class="{ 'text-sunset-orange-500 purple-theme:text-purple-500': item.is_current }"
                    >
                        {{ item.title }}
                    </Component>
                </li>
            </ol>
        </div>
    </nav>
</template>
